import * as CONSTANTS from "../constants";
import axios from "axios";
import { resolve } from "./resolve.jsx";
import { callBackendService, reGenerateToken } from "./generic";

// const FORGOT_ACC_REST_HOST = window.FORGOT_ACC_REST_HOST; // in dev for example value is: "http://sdea003:9080";
// const FORGOT_ACC_REST_BASE = window.FORGOT_ACC_REST_BASE; // in dev for example value is: "api/forget/v1";
// const FULL_REST_URL = FORGOT_ACC_REST_HOST + FORGOT_ACC_REST_BASE;
// const baseURL = window.base_URL;

const cem_key = window["CEM_KEY"];

const apiBaseURL = window["base_api_url"]; // 'https://apisit.mobily.com.sa/api'
const passwordCreteriaURL = window.passwordCreteria_URL;

console.log("apiBaseURL", apiBaseURL);

export async function verifyClient(requestBody) {
  let token = await reGenerateToken();
  let result = await callBackendService(
    apiBaseURL + "/register/v1/verify/client",
    requestBody,
    "POST",
    { Authorization: "Bearer " + token },
    { "cem-key": cem_key }
  );

  return result;
}

export async function verifyUsername(requestBody) {
  let token = await reGenerateToken();
  let result = await callBackendService(
    apiBaseURL + "/forget/v1/password/verify-username",
    requestBody,
    "POST",
    { Authorization: "Bearer " + token },
    { "cem-key": cem_key }
  );

  return result;
}

export async function sendResetLink(requestBody) {
  let token = await reGenerateToken();
  let result = await callBackendService(
    apiBaseURL + "/forget/v1/password",
    requestBody,
    "POST",
    { Authorization: "Bearer " + token },
    { "cem-key": cem_key }
  );

  return result;
}

export async function updatePassword(requestBody) {
  let token = await reGenerateToken();
  let result = await callBackendService(
    apiBaseURL + "/forget/v1/password/reset",
    requestBody,
    "POST",
    { Authorization: "Bearer " + token },
    { "cem-key": cem_key }
  );

  return result;
}

export async function verifyResetLink(requestBody) {
  let token = await reGenerateToken();
  let result = await callBackendService(
    apiBaseURL + "/forget/v1/transaction/verify",
    requestBody,
    "POST",
    { Authorization: "Bearer " + token },
    { "cem-key": cem_key }
  );
  return result;
}

export async function resetUsername(requestBody) {
  let token = await reGenerateToken();
  let result = await callBackendService(
    apiBaseURL + "/forget/v1/username",
    requestBody,
    "POST",
    { Authorization: "Bearer " + token },
    { "cem-key": cem_key }
  );
  return result;
}

export function getPasswordCreteria() {
  const url = `${apiBaseURL}/digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=account_mgmt_rules_info`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        "cem-key": cem_key,
      },
    })
      .then((res) => res.text())
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function validateRecaptcha(recaptchResKey) {
  const url = `${apiBaseURL}/utility/v1/google-recapchav2/validate`;
  let token = await reGenerateToken();
  var requestBody = {
    gRecaptchaResponse: recaptchResKey,
  };

  return await resolve(
    axios({
      method: "post",
      url: url,
      data: requestBody,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "cem-key": cem_key,
      },
    }).then((res) => res.data)
  );
}
